<div id="homepage-container" fxLayout="column">
  <mat-toolbar color="primary" id="homepage-toolbar">
    <span>
      <!--button mat-button>
        <mat-icon>home</mat-icon>
      </button-->
    </span>
    <div id="expanded-toolbar-right-panel" fxLayout="row">
      <!-- fxShow="false" fxShow.gt-sm -->
      <div id="expanded-toolbar-right-panel-lang-container">
        <mat-select name="lang" [(ngModel)]="lang" (selectionChange)="changeLanguage($event)"
          matTooltip="{{ 'general.tooltip.language' | translate }}">
          <mat-option value="it">IT</mat-option>
          <mat-option value="en">EN</mat-option>
        </mat-select>
      </div>
      <button mat-button (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        {{ 'homepage.button.logout' | translate }}
      </button>
    </div>
    <!--button mat-button [mat-menu-trigger-for]="menu" fxHide="false" fxHide.gt-sm>
    <mat-icon>menu</mat-icon>
  </button -->
  </mat-toolbar>
  <!-- mat-menu x-position="before" #menu="matMenu">
  <button mat-menu-item routerLink="/">
    <mat-icon>home</mat-icon>
    Home
  </button>
  <button mat-menu-item routerLink="/game">
    <mat-icon>gamepad</mat-icon>
    Play
  </button>
  <button mat-menu-item routerLink="/login" *ngIf="!isAuthenticated">
    <mat-icon>power_settings_new</mat-icon>
    Login
  </button>
  <button mat-menu-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    Logout
  </button>
</mat-menu -->
  <mat-sidenav-container id="homepage-content">
    <mat-sidenav #sidenav mode="side" #sidenav fxLayout="column" fxFlex fxLayoutAlign="space-around stretch"
      disableClose opened>
      <div style="display: grid;">
        <ng-container *ngFor="let tree of trees;">
          <app-folder-tree [mediaTree]="tree" (selectFolder)="selectFolder($event)"></app-folder-tree>
        </ng-container>
      </div>
    </mat-sidenav>

    <mat-sidenav-content fxLayout="column" fxFlex fxLayoutAlign="space-around stretch">
      <div id="content-container" fxFlex="1 1 100%" fxLayout="row">
        <app-file-manager></app-file-manager>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>